import {Routes} from '@angular/router';
import {VehiclesListComponent} from './features/entities/vehicles/vehicles-list/components/vehicles-list.component';
import {WarehouseComponent} from './features/warehouse/warehouse.component';
import {
  VehicleDetailsComponent
} from './features/entities/vehicles/vehicle/components/vehicle-details/vehicle-details.component';
import {NewVehicleComponent} from './features/entities/vehicles/vehicle/components/new-vehicle/new-vehicle.component';
import {SettingsComponent} from './features/settings/settings/settings.component';
import {UserComponent} from './features/entities/user/component/user/user.component';
import {StorageComponent} from './features/entities/storage/component/storage/storage.component';
import {ReportComponent} from './features/report/component/report-component/report.component';

export const routes: Routes = [
  {path: '', redirectTo: '/vehicles/all', pathMatch: 'full'},
  {
    path: 'vehicles',
    component: WarehouseComponent,
    title: 'Magazyn',
    data: {
      sidebar: {
        icon: 'pi pi-warehouse',
        label: 'Magazyn'
      }
    },
    children: [
      {
        path: 'all',
        component: VehiclesListComponent,
        title: 'Lista pojazdów',
        data: {
          sidebar: {
            icon: 'pi pi-list',
            label: 'Lista pojazdów'
          }
        }
      },
      {
        path: 'create',
        component: NewVehicleComponent,
        title: 'Nowy pojazd',
        data: {
          sidebar: {
            icon: 'pi pi-plus',
            label: 'Nowy pojazd'
          }
        }
      },
      {
        path: 'locations',
        component: StorageComponent,
        title: 'Lokalizacje',
        data: {
          sidebar: {
            icon: 'pi pi-map-marker',
            label: 'Lokalizacje'
          }
        }
      },
      {
        path: 'report',
        component: ReportComponent,
        title: 'Raporty',
        data: {
          sidebar: {
            icon: 'pi pi-chart-bar',
            label: 'Raporty'
          }
        }
      },
      {
        path: ':id',
        component: VehicleDetailsComponent,
        title: 'Pojazd',
      }
    ]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    title: 'Ustawienia',
    data: {
      sidebar: {
        icon: 'pi pi-cog',
        label: 'Ustawienia'
      }
    }
  },
  {
    path: 'user',
    component: UserComponent,
    title: 'Konto',
    data: {
      sidebar: {
        icon: 'pi pi-user',
        label: 'Konto'
      }
    }
  },
  {path: '**', redirectTo: ''}
];
